import { render } from "./PurchaseContentTable.vue?vue&type=template&id=5957feea&scoped=true&ts=true&lang=pug"
import script from "./PurchaseContentTable.vue?vue&type=script&lang=ts"
export * from "./PurchaseContentTable.vue?vue&type=script&lang=ts"

import "./PurchaseContentTable.vue?vue&type=style&index=0&id=5957feea&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5957feea"]])

export default __exports__